/**
 * @generated SignedSource<<77586322f750ae0b68f16053ceaefeac>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40

import type { ConcreteRequest } from 'relay-runtime';
export type KnowledgeGraphContentType = "BLOGPOST" | "PAGE" | "%future added value";
export type aiSnippetLoaderQuery$variables = {
  cloudId: string;
  contentId: string;
  contentType: KnowledgeGraphContentType;
  includeMe: boolean;
};
export type aiSnippetLoaderQuery$data = {
  readonly confluence_latestKnowledgeGraphObjectV2: {
    readonly __typename: "KnowledgeGraphObjectResponseV2";
    readonly objectData: string;
  } | null;
  readonly me?: {
    readonly user: {
      readonly accountId: string;
      readonly name: string;
    } | null;
  };
};
export type aiSnippetLoaderQuery = {
  response: aiSnippetLoaderQuery$data;
  variables: aiSnippetLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMe"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "args": [
    {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    },
    {
      "kind": "Variable",
      "name": "contentId",
      "variableName": "contentId"
    },
    {
      "kind": "Variable",
      "name": "contentType",
      "variableName": "contentType"
    },
    {
      "kind": "Literal",
      "name": "objectType",
      "value": "snippet_v2"
    }
  ],
  "concreteType": "KnowledgeGraphObjectResponseV2",
  "kind": "LinkedField",
  "name": "confluence_latestKnowledgeGraphObjectV2",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "objectData"
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "aiSnippetLoaderQuery",
    "selections": [
      (v5/*: any*/),
      {
        "condition": "includeMe",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "aiSnippetLoaderQuery",
    "selections": [
      (v5/*: any*/),
      {
        "condition": "includeMe",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
    "metadata": {},
    "name": "aiSnippetLoaderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";

export default node;
